//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
'use client';

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';

import AppsThatIntegrate from './_components/AppsThatIntegrate';
import CallToAction from './_components/CallToAction';
import Hero from './_components/DeveloperHero';
import WaysToIntegrate from './_components/WaysToIntegrate';
import WhyUseApi from './_components/WhyUseApi';

const Content = () => {
  return (
    <>
      <InverseHeader enter>
        <Hero />
      </InverseHeader>
      <WhyUseApi />
      <AppsThatIntegrate />
      <InverseHeader enter>
        <WaysToIntegrate />
      </InverseHeader>
      <CallToAction />
    </>
  );
};

export default Content;
